import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';
import { Colors } from '../../utils/theme';
import { AuthRoutes, RouteNames } from '../../enums/RouteEnums';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import OverviewToolbar from '../Common/Layout/OverviewToolbar';
import { HomeWork, Info, PersonRounded } from '@mui/icons-material';
import CustomAppBar from '../Common/Layout/CustomAppBar';
import ContactDetailsTabs from './InfoTabs/ContactDetailsTabs';
import Loader from '../Common/Loader';
import { IContact, useContactDetailsQuery } from '../../generated/graphql';

const ContactDetails: React.FunctionComponent = () => {
  const location = useLocation();
  const history = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const [contact, setContact] = useState<IContact | null>(null);

  const locationElements = location.pathname.split('/').filter((e) => e);
  const { data, loading } = useContactDetailsQuery({
    variables: {
      id: parseInt(locationElements[locationElements.length - 1])
    },
    fetchPolicy: 'no-cache'
  });
  const [value, setValue] = useState(0);
  const handleChange = (_: unknown, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (data && data.result) {
      dispatch({
        type: Actions.SetSelectedContact,
        payload: { name: data.result.fullName, company_name: data.result.company.name }
      });
      setContact(data.result as IContact);
    }
  }, [data]);

  const handleToContactsOverview = () => {
    dispatch({ type: Actions.ResetSelectedContact });
    history(AuthRoutes.Contacts);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <OverviewToolbar handleToOverview={handleToContactsOverview} navName={RouteNames.Contacts}>
        <Box className="centralize" sx={{ gap: '5px' }}>
          <PersonRounded />
          {state.selectedContact?.name || contact?.fullName}
          <Box
            sx={{ borderRight: `1px solid ${Colors.white}`, width: '1px', height: '100%' }}
          ></Box>
          <HomeWork />
          {state.selectedContact?.company_name || contact?.company.name}
        </Box>
      </OverviewToolbar>
      <Box>
        <CustomAppBar
          value={value}
          handleChange={handleChange}
          tabProps={[{ id: 'contact-details', title: 'Details', icon: Info }]}
        />
        {contact && <ContactDetailsTabs contact={contact} />}
      </Box>
      <Loader loading={loading} />
    </Box>
  );
};
export default ContactDetails;
